
<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-start wrap>
            <v-flex v-if="$user" xs12 sm10 offset-sm1 md6 offset-md3 offset-lg1 lg3 container-of-fullheight-element style="padding-bottom: 15px;">
                <shared-files-card v-on:upload-success="fetchFiles()" :user="$user"></shared-files-card>
            </v-flex>
            <v-flex v-if="!$user" xs12 sm10 offset-sm1 md6 offset-md3>
                <shared-files-card v-on:upload-success="fetchFiles()" :user="$user"></shared-files-card>
            </v-flex>
            <v-flex v-if="$user" xs12 sm12 md8 lg6 offset-md2 offset-lg1 class="container-of-fullheight-element"  style="padding-bottom: 15px;">
                <Myfilesbox ref="listFiles"></Myfilesbox>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import SharedFilesCard from '@/components/SharedFilesCard/ShareFilesCard';
    import { VFlex, VLayout, VContainer } from 'vuetify/lib'

    import AuthRepository from "@/repositories/AuthRepository";
    import Myfilesbox from "../components/MyFilesBox";

    export default {
        name: 'Home',
        components:{Myfilesbox, SharedFilesCard,VFlex, VLayout, VContainer},
        beforeMount(){
            if (this.$route.params.token) {
                this.token = this.$route.params.token;
                AuthRepository.verify(this.token)
                    .then((response) => {
                        if (response.data.error) {
                            this.$root.$emit('show-modal', {title: this.$t('Account verified'), message: response.data.message + " You can now log in!",type: '' });
                            this.$root.$emit('show-login-drawer', {email: response.data.email});
                        } else {
                            this.$root.$emit('show-modal', {title: this.$t('Verify account'),message: response.data.message,type: 'error' });
                        }
                    }).catch((response) =>{
                        this.$root.$emit('show-modal', {title: this.$t('Verify account'),message: response.data.message, type: 'error' });
                    });
            }
        },
        methods: {
            fetchFiles() {
                if (this.$refs.listFiles) {
                    this.$refs.listFiles.fetch();
                }
            }
        }
    };
</script>